import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useToast } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { gql, useMutation } from '@apollo/client';
import AdditionalAttachment from '../additional-attachment/additional-attachment';

const M_OTHER_ATTACHMENTS = gql`
	mutation saveOtherAttachments($id: String!, $attachments: JSON) {
		saveOtherAttachments(id: $id, attachments: $attachments) {
			id
		}
	}
`;

const AddOtherAttachmentModal = ({ npId = null, initData = [], onClose = () => null, onCallback = () => null }) => {
	const toast = useToast();
	const { t } = useTranslation();
	const [attachments, setAttachments] = useState(initData || []);
	const [saveOtherAttachments, { loading }] = useMutation(M_OTHER_ATTACHMENTS);

	return (
		<Modal size="3xl" closeOnEsc={!loading} closeOnOverlayClick={!loading} isOpen={true} onClose={() => onClose(false)} scrollBehavior="inside">
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>{t('Edit other attachments')}</ModalHeader>
				<ModalCloseButton isDisabled={loading} />
				<ModalBody>
					<AdditionalAttachment showLabel={false} initData={attachments} isEditing={true} onChange={setAttachments} />
				</ModalBody>
				<ModalFooter>
					<Button
						isDisabled={loading}
						onClick={() => {
							saveOtherAttachments({ variables: { id: npId, attachments } })
								.then(({ data }) => {
									onClose();
									onCallback();
								})
								.catch((error) => {
									if (error?.graphQLErrors?.length > 0) {
										error?.graphQLErrors.map(({ message }, i) =>
											toast({
												title: t(message),
												status: 'error',
												isClosable: true,
												position: 'bottom-right',
											}),
										);
									} else {
										toast({
											title: t(error?.message ? error?.message : 'something went wrong'),
											status: 'error',
											isClosable: true,
											position: 'bottom-right',
										});
									}
								});
						}}
						colorScheme="blue"
						float="right"
						mb={2}
					>
						{t('Save')}
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};

export default AddOtherAttachmentModal;
